import { parsePath } from "react-router-dom";
import { REPORTING_SCOPE_QUERY_PARAM } from "@components/reporting/reportingScope";

const CATALOG_SCOPE_PARAMS = [REPORTING_SCOPE_QUERY_PARAM, "entityId"];

/**
 * Whether a report catalog link is the current page. Catalog links share a
 * path (`/reporting` or `/accounting`) and differ only by their entity or
 * consolidation group param, so those params must match too.
 */
export const isCatalogLinkActive = ({
    to,
    pathname,
    search,
}: {
    to: string;
    pathname: string;
    search: string;
}) => {
    const target = parsePath(to);
    if (target.pathname !== pathname) {
        return false;
    }
    const targetParams = new URLSearchParams(target.search);
    const currentParams = new URLSearchParams(search);
    return CATALOG_SCOPE_PARAMS.every(
        (param) => targetParams.get(param) === currentParams.get(param),
    );
};
